module.exports = __webpack_public_path__ + "img/banner2.d1689ee7.jpg";